import * as React from "react";

interface IComponentProps {
	/**
	 * Notification title.
	 */
	title?: string;
	/**
	 * Notification body.
	 */
	body: string;
	/**
	 * Notification font awesome name.
	 */
	icon?: string;
}

export default class DefaultToast extends React.Component<IComponentProps, {}> {

	constructor(props: IComponentProps) {
		super(props);
	}

	render() {
		return (
			<div className={"c-notification-toast"}>
				{this.renderIcon()}
				<div className={"toast-content"}>
					{this.props.title && <div className={"toast-header"}>{this.props.title}</div>}
					<div className={"toast-body"}>
						{this.props.body}
					</div>
				</div>
			</div>
		);
	}

	renderIcon() {
		if (this.props.icon)
			return (
				<div className={"toast-icon"}>
					<i className={`fa fa-${this.props.icon}`}/>
				</div>
			);
	}
}
